export default {
    API_SERVER: `https://frozen-cliffs-87082.herokuapp.com`,
    API_KEY: process.env.REACT_APP_API_KEY
}